<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">
                    <header>
                        <figure><i class="icon icon-icon_layers"></i></figure>
                        <div>
                            <span class="breadcrumb">
                                Tag <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                    </header>

                    <main>

                         <languages :translations="resource.translations" :localesLoaded="localesLoaded" :locales="locales" v-model="locale"></languages>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">

                              <fieldset>
                                <h3>Détail</h3>
                                <p class="headline"></p>

                                <form-select label="Taxe" multiple="false" v-model="resource.type" :default="resource.type_id" :options="types"></form-select>
                                <form-select label="Pays" multiple="false" v-model="resource.country" :default="resource.country_id" :options="$store.state.countries"></form-select>
                                <form-text label="Pourcentage" v-model="resource.percentage"></form-text>

                              </fieldset>

                            </tab>
                        </tabs>

                    </main>
                </article>
            </div>
        </div>
    </transition>
</template>
<script>

    import TaxService from './TaxService.js';
    import TaxTypeService from '../taxtype/TaxTypeService.js';
    import Edit from '../../../layouts/Edit.vue';

    export default {
        extends: Edit,
        data () {
            return {
                types: []
            }
        },
        mounted: function(){

            TaxTypeService.all().then(response => {
                this.types = response.data
                this.isLoading = false
            })

            var countries = {}
            for (let item of this.$store.state.countries) {
                countries[this.resource.id] = item
            }

        },
        methods:{
            resourceLoaded: function(){
                this.setTranslations(['name','description']);
                this.initialize()
            },
            getResource: function(){
                return TaxService
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/config/tax/Edit.vue